"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var bech32 = __importStar(require("bech32"));
var bs58check_1 = __importDefault(require("bs58check"));
var base_1 = __importDefault(require("./base"));
var Digibyte = /** @class */ (function (_super) {
    __extends(Digibyte, _super);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function Digibyte(_a) {
        var network = _a.network;
        var _this = 
        // missing bip32 info in coininfo network for digibyte, we fill it mannually
        // https://electrum.readthedocs.io/en/latest/xpub_version_bytes.html
        _super.call(this, { network: network }) || this;
        _this.network.bip32 = { public: 0x0488b21e, private: 0x0488ade4 };
        _this.network.dustThreshold = 10000;
        _this.network.dustPolicy = "FIXED";
        _this.network.usesTimestampedTransaction = false;
        return _this;
    }
    Digibyte.prototype.validateAddress = function (address) {
        // bech32 address
        if (address.substring(0, 3) === "dgb") {
            if (bech32.decodeUnsafe(address)) {
                return true;
            }
        }
        // bs58 address
        var res = bs58check_1["default"].decodeUnsafe(address);
        if (!res)
            return false;
        return (res.length > 3 &&
            (res[0] === this.network.pubKeyHash || res[0] === this.network.scriptHash));
    };
    return Digibyte;
}(base_1["default"]));
exports["default"] = Digibyte;
//# sourceMappingURL=digibyte.js.map